/**
 * Map a fab-histogram analytics row onto chart keys.
 * Left axis / bars / capacity follow Hours vs Man-weeks vs Man-months.
 * Man-months = man-weeks ÷ weeks-in-bucket (average crew), same as the job Resource Histogram.
 * Right-axis S-curve (_cum) is always remaining hours.
 */
export function isCrewUnits(units) {
  return units === 'manweeks' || units === 'manmonths';
}

export function unitModeLabel(units) {
  if (units === 'manmonths') return 'Man-months';
  if (units === 'manweeks') return 'Man-weeks';
  return 'Man-hours';
}

export function crewDivisor(row = {}, units = 'hours') {
  if (units !== 'manmonths') return 1;
  return Math.max(Number(row.weekCount) || 1, 1);
}

export function plotChartRow(row = {}, series = [], units = 'hours') {
  const next = { ...row };
  const crew = isCrewUnits(units);
  const div = crewDivisor(row, units);
  const man = (v) => (Number(v) || 0) / div;
  next._total = crew ? man(row.manweeks) : row.total;
  next._cum = row.cumulative;
  next._cap = crew ? man(row.capacityMen) : row.capacityHours;
  series.forEach((name) => {
    next[name] = crew ? man(row[`${name}__mw`]) : (row[name] || 0);
    next[`${name}__men`] = row[`${name}__men`] || 0;
  });
  return next;
}
